// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-user-container {
  overflow: hidden;
  height: 100vh;
}
.create-user-container .user-container-section {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.create-user-container .sidebar {
  height: 100vh;
}
.create-user-container .header-navigation {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
  width: 99.5%;
}
.create-user-container .create-user-text {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  color: #2D2D2D;
  padding: 0.5rem;
}
.create-user-container .create-user {
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
}
.create-user-container .create-user::-webkit-scrollbar {
  width: 0px;
}
.create-user-container .create-user::-webkit-scrollbar-thumb {
  background: transparent;
}
.create-user-container .create-user {
  scrollbar-width: none;
}
.create-user-container .create-user-main {
  width: 97%;
  margin: auto;
  margin-top: 20px;
}
.create-user-container .create-user-form {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  padding: 30px;
  border-radius: 8px;
  margin-top: 50px;
}
.create-user-container .user-form {
  display: flex;
  gap: 50px;
}
.create-user-container .user-form .form-section {
  width: 50%;
}
.create-user-container .user-form .form-section .form-input {
  display: flex;
  margin-bottom: 40px;
  align-items: center;
  gap: 40px;
  position: relative;
}
.create-user-container .user-form .form-section .form-input input {
  height: 47px !important;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
  width: 80%;
  padding: 0px 10px;
}
.create-user-container .user-form .form-section .form-input select {
  height: 47px !important;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
  width: 80%;
  padding: 0px 10px;
}
.create-user-container .user-form .user-iput-label {
  position: absolute;
  top: -10px;
  left: 15px;
}
.create-user-container .number_inp {
  height: 45px !important;
  font-size: 20px;
  border: none !important;
}
.create-user-container .react-tel-input {
  border-radius: 6px;
  position: relative;
  width: 80px;
  height: 3rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
  cursor: pointer;
  padding: 0px 5px;
}
.create-user-container .react-tel-input input {
  border: none !important;
}
.create-user-container .react-tel-input .form-control {
  border-radius: 6px;
  position: relative;
  width: 60px;
  height: 3rem;
  margin: 10px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 0.5rem;
  color: #10132e;
  cursor: pointer;
  border: none;
  background-color: white;
}
.create-user-container .react-tel-input .selected-flag {
  width: 17px !important;
  padding: 0 !important;
}
.create-user-container .react-tel-input .selected-flag .arrow {
  display: none;
}
.create-user-container .react-tel-input .flag-dropdown {
  background-color: white;
  border: none !important;
  height: 3rem;
}
.create-user-container .phone_input {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 50px;
  width: 80%;
}
.create-user-container .phone_input input {
  border: none;
  outline: none;
  padding: 5px;
}
.create-user-container .phone_input .phone_bar {
  margin: 0 3px;
  color: black;
  font-size: 23px;
  height: 2.5rem;
}
.create-user-container .cancel-submit-btn {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}
.create-user-container .cancel-submit-btn .cancel-btn {
  border: 1px solid #0C3688;
  width: 128px;
  height: 32px;
  color: #0C3688;
  background-color: white;
  border-radius: 6.4px;
}
.create-user-container .cancel-submit-btn .submit-btn {
  width: 128px;
  height: 32px;
  border-radius: 6.4px;
  background-color: #0C3688;
  color: white;
}
.create-user-container .cancel-submit-btn .submit-btn:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
}
.create-user-container .cancel-submit-btn .loader-btn {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 768px) {
  .create-user-container .user-form {
    display: flex;
    flex-direction: column;
    gap: 0px;
  }
  .create-user-container .user-form .form-section {
    width: 100%;
    display: flex;
    gap: 20px;
  }
  .create-user-container .user-form .form-section .form-input input {
    width: 100%;
  }
  .create-user-container .create-user-form {
    padding: 10px;
  }
  .create-user-container .phone_input {
    width: 100%;
  }
  .create-user-container .react-tel-input input {
    width: 60px !important;
  }
  .create-user-container .user-form .form-section .user-input {
    width: 100%;
  }
  .create-user-container .user-form .form-section .form-input {
    position: relative;
    width: 48%;
  }
  .user-iput-label {
    position: absolute !important;
    font-size: 12px !important;
    top: -8px;
    left: 12px;
    background: white;
    width: auto !important;
  }
}
@media screen and (max-width: 480px) {
  .create-user-container .user-form .form-section .form-input {
    flex-direction: column;
    width: 100%;
    gap: 0px;
  }
  .create-user-container .user-form .form-section .form-input input {
    width: 100%;
  }
  .create-user-container .user-form .form-section .form-input select {
    width: 100%;
  }
  .create-user-container .user-form .form-section {
    width: 100%;
    flex-direction: column;
    gap: 0px;
  }
  .create-user-container .phone_input {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/CreateUser/CreateUser.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACR;AAEI;EACI,aAAA;AAAR;AAGI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AADR;AAII;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAFR;AAKI;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AAHR;AAKQ;EACI,UAAA;AAHZ;AAMQ;EACI,uBAAA;AAJZ;AAOQ;EACI,qBAAA;AALZ;AASI;EACI,UAAA;EACA,YAAA;EACA,gBAAA;AAPR;AAUI;EACI,2CAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AARR;AAWI;EACI,aAAA;EACA,SAAA;AATR;AAWQ;EACI,UAAA;AATZ;AAWY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAThB;AAWgB;EACI,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;AATpB;AAYgB;EACI,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;AAVpB;AAeQ;EACI,kBAAA;EACA,UAAA;EACA,UAAA;AAbZ;AAiBI;EACI,uBAAA;EACA,eAAA;EACA,uBAAA;AAfR;AAkBI;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAhBR;AAkBQ;EACI,uBAAA;AAhBZ;AAoBI;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;AAlBR;AAqBM;EACE,sBAAA;EACA,qBAAA;AAnBR;AAsBM;EACE,aAAA;AApBR;AAuBM;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;AArBR;AAwBI;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAtBR;AAuBQ;EACI,YAAA;EACA,aAAA;EACA,YAAA;AArBZ;AAwBQ;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAtBZ;AA0BI;EACI,aAAA;EACA,SAAA;EACA,gBAAA;AAxBR;AA0BQ;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,oBAAA;AAxBZ;AA2BQ;EACI,YAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;AAzBZ;AA4BQ;EACI,mEAAA;AA1BZ;AA6BQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;AA3BZ;AA8BU;EACE;IAAK,uBAAA;EA3Bf;EA4BU;IAAO,yBAAA;EAzBjB;AACF;;AA6BA;EAEI;IACI,aAAA;IACA,sBAAA;IACA,QAAA;EA3BN;EA6BM;IACI,WAAA;IACA,aAAA;IACA,SAAA;EA3BV;EA6BU;IACI,WAAA;EA3Bd;EAgCE;IACI,aAAA;EA9BN;EAiCE;IACI,WAAA;EA/BN;EAmCO;IACG,sBAAA;EAjCV;EAqCE;IACI,WAAA;EAnCN;EAsCE;IACI,kBAAA;IACA,UAAA;EApCN;EAuCE;IACI,6BAAA;IACA,0BAAA;IACA,SAAA;IACA,UAAA;IACA,iBAAA;IACA,sBAAA;EArCN;AACF;AAwCA;EACI;IACI,sBAAA;IACA,WAAA;IACA,QAAA;EAtCN;EAyCE;IACI,WAAA;EAvCN;EA0CE;IACI,WAAA;EAxCN;EA2CE;IACI,WAAA;IACA,sBAAA;IACA,QAAA;EAzCN;EA4CE;IACI,WAAA;EA1CN;AACF","sourcesContent":[".create-user-container {\n    overflow: hidden;\n    height: 100vh;\n\n    .user-container-section {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n    }\n\n    .sidebar {\n        height: 100vh;\n    }\n\n    .header-navigation {\n        background: #c0c8da;\n        height: 2.4rem;\n        border: 1px solid #c0c8da;\n        width: 99.5%;\n    }\n\n    .create-user-text {\n        font-family: \"Nunito\";\n        font-size: 12px;\n        font-weight: 500;\n        color: #2D2D2D;\n        padding: 0.5rem;\n    }\n\n    .create-user {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: auto;\n        overflow-x: hidden;\n        height: calc(100vh - 66px);\n\n        &::-webkit-scrollbar {\n            width: 0px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n            background: transparent;\n        }\n\n        & {\n            scrollbar-width: none;\n        }\n    }\n\n    .create-user-main {\n        width: 97%;\n        margin: auto;\n        margin-top: 20px;\n    }\n\n    .create-user-form{\n        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n        padding: 30px;\n        border-radius: 8px;\n        margin-top: 50px;\n    }\n\n    .user-form {\n        display: flex;\n        gap: 50px;\n\n        .form-section {\n            width: 50%;\n\n            .form-input {\n                display: flex;\n                margin-bottom: 40px;\n                align-items: center;\n                gap: 40px;\n                position: relative;\n\n                input{\n                    height: 47px !important;\n                    border: 1px solid #ccc;\n                    border-radius: 5px;\n                    outline: none;\n                    width: 80%;\n                    padding: 0px 10px;\n                }\n\n                select{\n                    height: 47px !important;\n                    border: 1px solid #ccc;\n                    border-radius: 5px;\n                    outline: none;\n                    width: 80%;\n                    padding: 0px 10px;\n                }\n            }\n        }\n\n        .user-iput-label {\n            position: absolute;\n            top: -10px;\n            left: 15px;\n        }\n    }\n\n    .number_inp{\n        height: 45px !important;\n        font-size: 20px;\n        border: none !important;\n    }\n\n    .react-tel-input {\n        border-radius: 6px;\n        position: relative;\n        width: 80px;\n        height: 3rem;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        color: #10132e;\n        cursor: pointer;\n        padding: 0px 5px;\n\n        input{\n            border: none !important;\n        }\n      }\n\n    .react-tel-input .form-control {\n        border-radius: 6px;\n        position: relative;\n        width: 60px;\n        height: 3rem;\n        margin: 10px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        padding: 0rem 0.5rem;\n        color: #10132e;\n        cursor: pointer;\n        border: none;\n        background-color: white;\n      }\n\n      .react-tel-input .selected-flag {\n        width: 17px !important;\n        padding: 0 !important;\n      }\n    \n      .react-tel-input .selected-flag .arrow {\n        display: none;\n      }\n\n      .react-tel-input .flag-dropdown {\n        background-color: white;\n        border: none !important;\n        height: 3rem;\n      }\n\n    .phone_input {\n        display: flex;\n        align-items: center;\n        border: 1px solid #ccc;\n        border-radius: 5px;\n        height: 50px;\n        width: 80%;\n        input {\n            border: none;\n            outline: none;\n            padding: 5px;\n        }\n\n        .phone_bar {\n            margin: 0 3px;\n            color: black;\n            font-size: 23px;\n            height: 2.5rem;\n        }\n    }\n\n    .cancel-submit-btn{\n        display: flex;\n        gap: 15px;\n        margin-top: 20px;\n\n        .cancel-btn{\n            border: 1px solid #0C3688;\n            width: 128px;\n            height: 32px;\n            color: #0C3688;\n            background-color: white;\n            border-radius: 6.4px;\n        }\n\n        .submit-btn{\n            width: 128px;\n            height: 32px;\n            border-radius: 6.4px;\n            background-color: #0C3688;\n            color: white;\n        }\n\n        .submit-btn:disabled{\n            background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n        }\n\n        .loader-btn {\n            border: 3px solid #f3f3f3;\n            border-top: 3px solid #3498db;\n            border-radius: 50%;\n            width: 18px;\n            height: 18px;\n            animation: spin 1s linear infinite;\n            display: inline-block;\n            vertical-align: middle;\n          }\n          \n          @keyframes spin {\n            0% { transform: rotate(0deg); }\n            100% { transform: rotate(360deg); }\n          }\n    }\n}\n\n@media screen and (max-width: 768px) {\n\n    .create-user-container .user-form {\n        display: flex;\n        flex-direction: column;\n        gap: 0px;\n\n        .form-section{\n            width: 100%;\n            display: flex;\n            gap: 20px;\n\n            .form-input input{\n                width: 100%;\n            }\n        }\n    }\n\n    .create-user-container .create-user-form {\n        padding: 10px;\n    }\n\n    .create-user-container .phone_input {\n        width: 100%;\n    }\n\n    .create-user-container .react-tel-input {\n         input{\n            width: 60px !important;\n        }\n    }\n\n    .create-user-container .user-form .form-section .user-input {\n        width: 100%;\n    }\n\n    .create-user-container .user-form .form-section .form-input {\n        position: relative;\n        width: 48%;\n    }\n\n    .user-iput-label {\n        position: absolute !important;\n        font-size: 12px !important;\n        top: -8px;\n        left: 12px;\n        background: white;\n        width: auto !important;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .create-user-container .user-form .form-section .form-input {\n        flex-direction: column;\n        width: 100%;\n        gap: 0px;\n    }\n\n    .create-user-container .user-form .form-section .form-input input{\n        width: 100%;\n    }\n\n    .create-user-container .user-form .form-section .form-input select{\n        width: 100%;\n    }\n\n    .create-user-container .user-form .form-section {\n        width: 100%;\n        flex-direction: column;\n        gap: 0px;\n    }\n\n    .create-user-container .phone_input {\n        width: 100%;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
